import React, { useEffect, useState } from "react";
import Button from "../Button";
import Input from "../Input";
import QuotablesGroup from "../registration/QuotablesGroup";
import Loading from "../common/Loading";
import { fetchSampleQuotables } from "../../lib/SamplesData";
import { post } from "../../lib/Fetching";
import EditPrice from "./EditPrice";
import { isEqual } from "underscore";

export default function EditSamplePricing({ sampleId, onChange }) {
  const [loaded, setLoaded] = useState(false);
  const [originalPrices, setOriginalPrices] = useState([]);
  const [prices, setPrices] = useState([]);
  const [reason, setReason] = useState("");
  const [sampleQuotables, setSampleQuotables] = useState(null);

  const findOriginalPrice = sampleQuotableId =>
    originalPrices.find(p => p.id === sampleQuotableId);

  const findPrice = sampleQuotableId => prices.find(p => p.id === sampleQuotableId);

  const changedPrices = prices.filter(p => {
    const originalPrice = findOriginalPrice(p.id);
    return !isEqual(originalPrice, p);
  });

  const canSave = changedPrices.length > 0 && reason && reason.trim().length > 0;

  const fetchData = () => {
    fetchSampleQuotables(sampleId).then(({ sample_quotables }) => {
      setSampleQuotables(sample_quotables);
      const fetchedPrices = sample_quotables.map(sq => ({
        id: sq.id,
        price: sq.price,
        ignore_turnaround_premium: sq.ignore_turnaround_premium
      }));
      setOriginalPrices(fetchedPrices);
      setPrices(fetchedPrices);
      setLoaded(true);
      setReason("");
    });
  };

  const handleSavePrices = () => {
    if (!canSave) return;
    post("/registration/sample_quotable_prices/update_many", {
      sample_id: sampleId,
      prices: changedPrices,
      reason
    })
      .then(fetchData)
      .then(() => onChange && onChange())
      .catch(e => {
        alert(e);
      });
  };

  useEffect(fetchData, [sampleId]);

  if (!loaded) return <Loading loading={!loaded} />;

  const updatePrice = price => {
    setPrices(prices.filter(p => p.id !== price.id).concat(price));
  };

  const renderPrice = quotable => {
    const price = findPrice(quotable.sample_quotable_id);
    if (!price) return null;
    const originalPrice = findOriginalPrice(quotable.sample_quotable_id);
    return <EditPrice price={price} originalPrice={originalPrice} updatePrice={updatePrice} />;
  };

  const quotables = sampleQuotables.map(sq => sq.quotable);

  return (
    <div
      className="basic-panel with-padding with-rounded-corners with-shadow"
      style={{ marginBottom: 10, maxWidth: 1300 }}
    >
      <div className="row">
        <div className="col-md-2">
          <Button
            title="Save Prices"
            primary
            block
            disabled={!canSave}
            onClick={handleSavePrices}
          />
        </div>
        <div className="col-md-10">
          <Input
            placeholder="Enter reason for price change. **This reason will be visible on the invoice**"
            value={reason}
            onChange={e => setReason(e.target.value)}
            className="form-control"
          />
        </div>
      </div>
      <hr />
      <QuotablesGroup
        selectSampleQuotables
        renderPrice={renderPrice}
        quotables={quotables}
        hideCheckbox={true}
      />
    </div>
  );
}
